import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';

const Container = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

const ColumnsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  gap: theme.spacing(16),
  alignItems: 'flex-end',
  padding: `0 ${theme.spacing(12)}`,
}));

const Column = styled(Skeleton)<{ heightInPercentages: number }>(
  ({ theme, heightInPercentages }) => ({
    flex: 1,
    height: `${heightInPercentages}%`,
    transform: 'none',
    borderRadius: theme.spacing(5),
  }),
);

const XAxis = styled(Skeleton)(({ theme }) => ({
  flex: `0 0 ${theme.spacing(30)}`,
}));

const generateRandomArray = (length: number) => {
  const randomNumbers = [];
  for (let i = 0; i < length; i++) {
    const randomNum = Math.floor(Math.random() * 51) + 50;
    randomNumbers.push(randomNum);
  }
  return randomNumbers;
};

const percentagesArray = [100, ...generateRandomArray(11)];

export const AreaChartSkeleton = () => {
  return (
    <Container data-testid="tarrif-summary-usage-chart-skeleton">
      <ColumnsContainer>
        {percentagesArray.map((percentage, i) => (
          <Column key={i} heightInPercentages={percentage} />
        ))}
      </ColumnsContainer>
      <XAxis />
    </Container>
  );
};
